export const PROPERTY_SEARCH_FORM = 'propertySearch';
export const TAB_INDEX = '1000';
export const EMPTY_VALUE = '';

export enum SearchTypeFormNames {
  SEARCH_BY = 'searchBy',
  ADDRES_SEARCH = 'addressSearch',
  OWNER_SEARCH = 'ownerSearch',
  DRIVERS_SEARCH = 'driversSearch',
  HOB_CODES = 'hobCodes',
}

export enum LocationFormNames {
  COUNTY = 'hobCodes.countyHob',
  CITY = 'hobCodes.cityHob',
  VILLAGE = 'hobCodes.villageHob',
}

export enum AddressSearchFormNames {
  HOUSE = 'addressSearch.streetNumber',
  STREET = 'addressSearch.streetName',
}

export enum OwnerSearchFormNames {
  FIRST = 'ownerSearch.firstName',
  MIDDLE = 'ownerSearch.lastName',
  LAST_CORP = 'ownerSearch.corporationName',
}

export enum PropertyFormLabels {
  COUNTY = 'County',
  CITY = 'City/Town',
  VILLAGE = 'Village',
  ADDRES_SEARCH = 'Address Search',
  OWNER_SEARCH = 'Owner Search',
  DRIVERS_SEARCH = 'Block Lot Search',
  ADDRESS_SEARCH = 'Address Search',
  HOUSE = 'House',
  STREET = 'Street',
  LAST_CORP = 'Last/Corp',
  FIRST = 'First name',
  MIDDLE = 'Middle',
}

export enum PropertyFormPlaceholders {
  COUNTY = 'Choose County',
  CITY = 'All Towns',
  VILLAGE = 'All Villages',
}

export enum USStateCodes {
  NY = 'NY',
  NJ = 'NJ',
}

export const PROPERTY_SEARCH_FORM_INITIAL_VALUES = {
  [SearchTypeFormNames.SEARCH_BY]: SearchTypeFormNames.ADDRES_SEARCH,
  [SearchTypeFormNames.HOB_CODES]: {
    countyHob: EMPTY_VALUE,
    cityHob: EMPTY_VALUE,
    villageHob: EMPTY_VALUE,
  },
  [SearchTypeFormNames.ADDRES_SEARCH]: {
    streetNumber: EMPTY_VALUE,
    streetName: EMPTY_VALUE,
  },
  [SearchTypeFormNames.OWNER_SEARCH]: {
    firstName: EMPTY_VALUE,
    lastName: EMPTY_VALUE,
    corporationName: EMPTY_VALUE,
  },
  [SearchTypeFormNames.DRIVERS_SEARCH]: {},
};
